import { useNavigate } from "react-router-dom";

export default function About() {
  const navigate = useNavigate();

  const items = [
    { key: "user",    label: "用户协议",             icon: "ri-file-text-line",    desc: "使用 天鼎AI 前请仔细阅读" },
    { key: "privacy", label: "隐私政策",             icon: "ri-shield-check-line", desc: "了解我们如何保护您的数据" },
    { key: "risk",    label: "风险提示与免责声明",    icon: "ri-alert-line",       desc: "模拟投资风险须知" },
    { key: "contact", label: "联系客服",             icon: "ri-customer-service-2-line", desc: "在线客服 · 微信咨询" },
  ] as const;

  return (
    <div className="flex-1 px-4 py-4">
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => navigate(-1)}
          className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center cursor-pointer shrink-0">
          <i className="ri-arrow-left-s-line text-foreground-600 text-sm" />
        </button>
        <h1 className="text-base font-bold text-foreground-950">关于</h1>
      </div>

      <div className="bg-white rounded-xl border border-background-200/60 overflow-hidden">
        <div className="divide-y divide-background-100">
          {items.map((item) => (
            <button key={item.key} onClick={() => navigate(`/profile/about/${item.key}`)}
              className="w-full flex items-center gap-3 px-4 py-4 cursor-pointer hover:bg-background-50 transition-colors">
              <div className="w-9 h-9 rounded-xl bg-background-50 flex items-center justify-center">
                <i className={`${item.icon} text-foreground-400 text-lg`} />
              </div>
              <div className="flex-1 text-left">
                <p className="text-sm font-medium text-foreground-950">{item.label}</p>
                <p className="text-[10px] text-foreground-400 mt-0.5">{item.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
